import React from 'react';
import styled from 'styled-components';
import { node, string, func } from 'prop-types';

const Link = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  color: #f28000;
  font-size: 16px;
  line-height: 1.5;
`;

const OrangeLink = ({
  href, handleClick, onMouseOver, children,
}) => <Link onMouseOver={onMouseOver} onClick={() => handleClick()} href={href}>{children}</Link>;

OrangeLink.propTypes = {
  children: node.isRequired,
  href: string.isRequired,
  handleClick: func.isRequired,
  onMouseOver: func,
};

OrangeLink.defaultProps = {
  onMouseOver: () => {},
};

export default OrangeLink;
